// extracted by mini-css-extract-plugin
export default {"navbar":"UDgBljxi","shrink":"GKnqkj+O"};